import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "10",
  height: "11",
  viewBox: "0 0 10 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.55806 0.683058C4.80214 0.438981 5.19786 0.438981 5.44194 0.683058L9.81694 5.05806C10.061 5.30214 10.061 5.69786 9.81694 5.94194C9.57286 6.18602 9.17714 6.18602 8.93306 5.94194L5.625 2.63388V9.875C5.625 10.2202 5.34518 10.5 5 10.5C4.65482 10.5 4.375 10.2202 4.375 9.875V2.63388L1.06694 5.94194C0.822864 6.18602 0.427136 6.18602 0.183058 5.94194C-0.0610194 5.69786 -0.0610194 5.30214 0.183058 5.05806L4.55806 0.683058Z",
  fill: "#6F798A"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };